import styled, { keyframes, css } from 'styled-components';

const slideUp = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  70% {
    transform: translateY(-10px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-end;
  box-shadow: ${({ theme }) => theme.boxShadow.small};
`;

export const ShortcutWrapper = styled.div<{ $isVisible: boolean }>`
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  transform-origin: bottom;
  max-height: ${({ $isVisible }) => ($isVisible ? '100px' : '0')};
  overflow: hidden;
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  transition: all 1s ease-out;

  ${({ $isVisible }) =>
    $isVisible &&
    css`
      animation: ${slideUp} 1s ease-out forwards;
    `}
`;

export const InfoWrapper = styled.div`
  display: flex;
  max-width: 840px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ShortcutTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const BoldText = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  padding: 20px 32px 24px 32px;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.black3};
  background-color: ${({ theme }) => theme.colors.white};
`;
